import React, { Component } from 'react';

import moment, { min } from 'moment';

import GroupMeView from './GroupMeView';
import GroupManageView from './GroupManageView';
import GroupYouView from './GroupYouView';

export default class GroupsViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {
            currentTab: 'manage',
            manageActive: false,
            manageIsNew: false,
            groupForm: {
                groupId: -1,
                groupTypeId: 0,
                clientAccountId: "",
                createdBy: "",
                createDate: "",
                lastUpdatedBy: "",
                lastUpdateDate: "",
                joinCode: "",
                viewCode: "",
                name: "",
                description: "",
                isPublic: false,
                myLocationMembers: [],
                yourLocationMembers: [],
                viewerMembers: []
            },
            youGroupForm: {
                groupId: -1,
                name: "",
                description: "",
                myLocationMembers: []
            },
            enteredGroupCode: "",
            minimizer: {
                myLoc: false,
                youLoc: false,
                viewers: false
            },
            expandedClientAccount: null
        }

        this.setManageActive = this.setManageActive.bind(this);
        this.setCurrentTab = this.setCurrentTab.bind(this);
        this.setMinimizer = this.setMinimizer.bind(this);
        this.setExpandedClientAccount = this.setExpandedClientAccount.bind(this);

        this.setEnteredGroupCode = this.setEnteredGroupCode.bind(this);

        this.editYouGroupForm = this.editYouGroupForm.bind(this);
        this.editGroupForm = this.editGroupForm.bind(this);
        this.newGroupForm = this.newGroupForm.bind(this);
        this.blankGroupForm = this.blankGroupForm.bind(this);
        this.existingGroupForm = this.existingGroupForm.bind(this);
        this.isGroupFormValid = this.isGroupFormValid.bind(this);

        this.showScanCode = this.showScanCode.bind(this);

        this.submitScanCode = this.submitScanCode.bind(this);
        this.submitScanCodeManual = this.submitScanCodeManual.bind(this);
        this.startScan = this.startScan.bind(this);
        this.postScanHandler = this.postScanHandler.bind(this);
        this.postScanHandlerManual = this.postScanHandlerManual.bind(this);

        this.createNewGroup = this.createNewGroup.bind(this);
        this.saveGroup = this.saveGroup.bind(this);
        this.deleteGroupMember = this.deleteGroupMember.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.groupModeIndex != prevProps.groupModeIndex) {
            this.setState({
                currentTab: 'manage',
                manageActive: false,
                manageIsNew: false,
                groupForm: {
                    groupId: -1,
                    groupTypeId: 0,
                    clientAccountId: "",
                    createdBy: "",
                    createDate: "",
                    lastUpdatedBy: "",
                    lastUpdateDate: "",
                    joinCode: "",
                    viewCode: "",
                    name: "",
                    description: "",
                    isPublic: false,
                    myLocationMembers: [],
                    yourLocationMembers: [],
                    viewerMembers: []
                },
                youGroupForm: {
                    groupId: -1,
                    name: "",
                    description: "",
                    myLocationMembers: []
                },
                enteredGroupCode: "",
                minimizer: {
                    myLoc: false,
                    youLoc: false,
                    viewers: false
                },
                expandedClientAccount: null
            });
        }
    }

    setManageActive(manageActive, manageIsNew) {
        if (manageActive != this.state.manageActive) {
            let self = this;

            let tmpManageIsNew = (manageIsNew != undefined ? manageIsNew : false);
            let tmpGroupForm = (this.state.currentTab === 'manage' ? tmpManageIsNew && manageActive ? self.newGroupForm() : !tmpManageIsNew && manageActive ? self.existingGroupForm() : self.blankGroupForm() : self.blankGroupForm());
            let tmpYouGroupForm = (this.state.currentTab != 'manage' && !tmpManageIsNew && manageActive ? self.existingGroupForm() : self.state.youGroupForm);

            let tmpMinimizer = this.state.minimizer;
            let tmpTopBarSettings = {
                actionFunction: null,
                backFunction: null
            }
            if (manageActive) {
                tmpTopBarSettings.backFunction = () => {
                    self.setManageActive(false, false);
                }
                // tmpTopBarSettings.actionFunction = this.props.topBarSettings.actionFunction
                tmpTopBarSettings.actionFunction = null;
            } else {
                tmpTopBarSettings.icon = "refresh";
                tmpTopBarSettings.actionFunction = () => { self.props.defaultTopBarAction() };
                tmpMinimizer = {
                    myLoc: false,
                    youLoc: false,
                    viewers: false
                }
            }

            self.setState({ manageActive: manageActive, manageIsNew: tmpManageIsNew, groupForm: tmpGroupForm, youGroupForm: tmpYouGroupForm, enteredGroupCode: "", minimizer: tmpMinimizer, expandedClientAccount: null }, () => {
                self.props.setTopBarSettings(tmpTopBarSettings)
            });
        }
    }

    setCurrentTab(tab) {
        if (tab != this.state.currentTab) {
            this.setState({ currentTab: tab });
        }
    }

    setMinimizer(type) {
        let minimizer = this.state.minimizer;

        if (minimizer[type] != undefined) {
            minimizer[type] = !minimizer[type];
        }

        this.setState({ minimizer: minimizer });
    }

    setExpandedClientAccount(clientAccountId) {
        this.setState({ expandedClientAccount: (clientAccountId === this.state.expandedClientAccount ? null : clientAccountId) });
    }

    setEnteredGroupCode(value) {
        if (value.length <= 5 && /^[A-Za-z0-9]*$/.test(value)) {
            this.setState({ enteredGroupCode: value.toUpperCase() });
        }
    }

    editYouGroupForm(property, value, e) {
        let self = this;
        let tmpYouGroupForm = self.state.youGroupForm;
        tmpYouGroupForm[property] = value;
        self.setState({ youGroupForm: tmpYouGroupForm }, () => {
            let topObject = {
                icon: "save",
                actionFunction: () => { self.props.locationJoinGroup(tmpYouGroupForm.groupId, tmpYouGroupForm.myLocationMembers, self.postScanHandler) }
            }
            self.props.setTopBarSettings(topObject);
        });
    }

    editGroupForm(property, value, e) {
        if (this.state.groupForm[property] != undefined && (this.state.groupForm[property] != value || typeof value === 'object')) {
            let self = this;
            let tmpGroupForm = this.state.groupForm;
            tmpGroupForm[property] = value;
            this.setState({ groupForm: tmpGroupForm }, () => {
                let topObject = {
                    icon: "save",
                    actionFunction: null
                }
                if (self.isGroupFormValid()) {
                    topObject = {
                        icon: "save",
                        actionFunction: () => {
                            if (self.isGroupFormValid()) {
                                if (self.state.manageIsNew) {
                                    self.createNewGroup()
                                } else {
                                    self.saveGroup();
                                }
                            }
                        }
                    }
                }
                self.props.setTopBarSettings(topObject);
            });
        }
    }

    newGroupForm() {
        let caId = this.props.groupModeIndex === 0 ?
            this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
            : this.props.accountInfo.primaryClientAccount;

        return {
            groupId: -1,
            groupTypeId: 1,
            clientAccountId: caId,
            createdBy: this.props.accountInfo.userId,
            createDate: moment().format(),
            lastUpdatedBy: this.props.accountInfo.userId,
            lastUpdateDate: moment().format(),
            joinCode: "",
            viewCode: "",
            name: "",
            description: "",
            isPublic: false,
            myLocationMembers: [],
            yourLocationMembers: [],
            viewerMembers: []
        }
    }

    blankGroupForm() {
        return {
            groupId: -1,
            groupTypeId: 0,
            clientAccountId: "",
            createdBy: "",
            createDate: "",
            lastUpdatedBy: "",
            lastUpdateDate: "",
            joinCode: "",
            viewCode: "",
            name: "",
            description: "",
            isPublic: false,
            myLocationMembers: [],
            yourLocationMembers: [],
            viewerMembers: []
        }
    }

    existingGroupForm() {
        let activeList = this.state.currentTab === 'manage' ? this.props.myGroups : this.props.yourGroups;
        for (var i = 0; i < activeList.length; i++) {
            if (activeList[i].groupId === this.props.activeGroupId) {
                let tmpForm = {};
                Object.keys(activeList[i]).forEach(key => {
                    if (typeof activeList[i][key] === 'object' && activeList[i][key].length != undefined) {
                        let tmpList = [];
                        activeList[i][key].forEach(li => {
                            tmpList.push(li);
                        });
                        tmpForm[key] = tmpList;
                    } else {
                        tmpForm[key] = activeList[i][key];
                    }
                });
                return tmpForm;
            }
        }
        return this.blankGroupForm();
    }

    isGroupFormValid() {
        let groupForm = this.state.groupForm;
        return (groupForm.name.trim().length > 0 && groupForm.description.trim().length > 0 && (groupForm.myLocationMembers.length > 0 || this.props.groupModeIndex === 1));
    }

    showScanCode(code, message) {
        alert((
            <div className={"group-code-shower-outer"}>
                <div className={"message"}>{message}</div>
                <div className={"code-text"}>{code}</div>
            </div>
        ));
    }

    submitScanCode() {
        let self = this;
        if (self.state.enteredGroupCode.length === 5) {
            self.props.initialJoinGroup(self.state.enteredGroupCode, self.postScanHandler);
        }
    }

    submitScanCodeManual() {

        let self = this;
        if (this.state.groupForm != undefined && this.state.groupForm != null && this.state.groupForm.viewCode != undefined && this.state.groupForm.viewCode != null) {

            self.props.initialJoinGroup(this.state.groupForm.viewCode, self.postScanHandlerManual);
        }
    }

    startScan() {
        let self = this;
        self.props.startScan(self.postScanHandler);
    }

    postScanHandler(rCode) {
        let self = this;

        switch (rCode.responseMessage) {
            case "join":
                let tmpForm = self.state.youGroupForm;
                tmpForm.name = rCode.name;
                tmpForm.description = rCode.description;
                tmpForm.groupId = rCode.groupId;
                tmpForm.myLocationMembers = rCode.myLocationMembers;

                self.setState({ youGroupForm: tmpForm }, () => {
                    self.setManageActive(true, true);
                });
                break;
            case "joinUpdated":
                alert("Joined " + rCode.name + " successfully");
                self.setManageActive(false, false);
                break;
            case "viewExists":
                alert("You already have view access to " + rCode.name);
                self.setState({ enteredGroupCode: "" });
                break;
            case "view":
                alert("You now have view access to " + rCode.name);
                self.setState({ enteredGroupCode: "" });
                break;
        }

    }

    postScanHandlerManual(rCode) {
        let self = this;

        switch (rCode.responseMessage) {
            case "viewExists":
                alert("You already have view access to " + rCode.name);
                self.setState({ enteredGroupCode: "" });
                break;
            case "view":
                let tmpForm = self.state.groupForm;
                this.props.myGroups.forEach(group => {
                    if (group.groupId === tmpForm.groupId) {
                        tmpForm.viewerMembers = group.viewerMembers;
                    }
                })
                alert("You now have view access to " + rCode.name);
                self.setState({ enteredGroupCode: "", groupForm: tmpForm });
                break;
        }

    }

    createNewGroup() {
        let self = this;
        this.props.createNewGroup(this.state.groupForm, () => {
            self.setManageActive(false, false);
        });
    }

    saveGroup() {
        let self = this;
        self.props.saveGroup(self.state.groupForm, () => {
            self.setState({ groupForm: self.existingGroupForm() });
            alert(self.state.groupForm.name + " Saved");
        });
    }

    deleteGroupMember(groupName, memberName, memberIdList) {
        let self = this;
        self.props.deleteGroupMember(groupName, memberName, memberIdList, () => {
            self.setState({ groupForm: self.existingGroupForm() });
            alert(memberName + " removed from " + groupName);
        });
    }

    render() {

        let tabHighlighterStyle = {
            left: (this.state.currentTab === 'manage' ? '0%' : '50%')
        }

        return (
            <div className={"groups-central-outer" + (this.props.isScanMode ? " hidden" : "")}>
                <div className={"stackup-tab-container" + (this.state.manageActive ? " hidden" : "")}>
                    <div className={"tab"} onClick={this.setCurrentTab.bind(null, 'manage')}>{"Manage"}</div>
                    <div className={"tab"} onClick={this.setCurrentTab.bind(null, 'join')}>{"Join"}</div>
                    <div className={"tab-highlighter"} style={tabHighlighterStyle}></div>
                </div>
                <GroupMeView
                    isCenter={this.state.currentTab === 'manage'}
                    isActive={!this.state.manageActive}
                    setManageActive={this.setManageActive}
                    myGroups={this.props.myGroups}
                    activeGroupId={this.props.activeGroupId}
                    setMyActiveGroupId={this.props.setMyActiveGroupId}
                    deleteGroup={this.props.deleteGroup}
                    showScanCode={this.showScanCode}
                />
                <GroupYouView
                    isCenter={this.state.currentTab === 'join'}
                    isActive={!this.state.manageActive}
                    setManageActive={this.setManageActive}
                    enteredGroupCode={this.state.enteredGroupCode}
                    setEnteredGroupCode={this.setEnteredGroupCode}
                    startScan={this.startScan}
                    submitScanCode={this.submitScanCode}
                    yourGroups={this.props.yourGroups}
                    viewGroups={this.props.viewGroups}
                    activeGroupId={this.props.activeGroupId}
                    setMyActiveGroupId={this.props.setMyActiveGroupId}
                    deleteGroupMember={this.deleteGroupMember}
                />

                <GroupManageView
                    groupModeIndex={this.props.groupModeIndex}
                    currentTab={this.state.currentTab}
                    locationMap={this.props.locationMap}
                    editYouGroupForm={this.editYouGroupForm}
                    editGroupForm={this.editGroupForm}
                    groupForm={this.state.groupForm}
                    youGroupForm={this.state.youGroupForm}
                    isActive={this.state.manageActive}
                    isNew={this.state.manageIsNew}
                    setManageActive={this.setManageActive}
                    deleteGroupMember={this.deleteGroupMember}
                    setDeleteMemberId={this.props.setDeleteMemberId}
                    deleteMemberId={this.props.deleteMemberId}
                    setMinimizer={this.setMinimizer}
                    minimizer={this.state.minimizer}
                    expandedClientAccount={this.state.expandedClientAccount}
                    setExpandedClientAccount={this.setExpandedClientAccount}
                    submitScanCodeManual={this.submitScanCodeManual}
                />
            </div>
        );
    }
}

